/*
 * @Author: Michael 
 * @Date: 2019-02-18 17:12:54 
 * @Last Modified by: 吴文洁
 * @Last Modified time: 2019-10-17 18:52:17
 * 弹幕类
 */

import dealWithName from '@/common/filters/dealWithName';
export interface BarrageItem {
  name: string
  desc: string
  avatar: string,
  hasSpecial: boolean
}
class Barrage {
  barrageList: Array<BarrageItem>
  maxTop: number = 5;
  duration: number; // 弹幕移动时间
  timer: any;
  parentDom: HTMLElement;
  constructor(parentDom: HTMLElement, barrageList: Array<BarrageItem>, duration: number) {
    this.parentDom = parentDom;
    this.barrageList = barrageList;
    this.duration = duration;
  }

  public init(): void {
    let create = this._create.call(this);
    create.call(this);
    this.timer = setInterval(() => {
      create.call(this);
    }, 2000);
  }

  _create(): Function {
    const barrageDom = document.createElement('div');
    barrageDom.className = 'barrage-content';
    barrageDom.style.transition = this.duration + "ms linear";

    return function (this: Barrage) {
      const barrageItem = this.barrageList.shift();
      if (barrageItem) {
        const { name, desc, avatar, hasSpecial} = barrageItem;
        const ownDom = barrageDom.cloneNode(true);
        (ownDom as HTMLElement).innerHTML = `
          <img class="text-avatar" src=${avatar} />
          <span class="text-content">${dealWithName(name)} </span>
          <span class="text-content">${desc}</span>
        `;
        (ownDom as HTMLElement).style.top = Math.random() < 0.5 ? "1rem" : '1.8rem';
        if (hasSpecial) {
          (ownDom as HTMLElement).className = 'barrage-content hasSpecial';
          (ownDom as HTMLElement).style.background = `url('https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309530532.png')`;
          (ownDom as HTMLElement).style.backgroundSize = "100% 100%";
          const oFrag = document.createDocumentFragment();

          const goldenBorderDom = document.createElement('div');
          goldenBorderDom.className = 'golden-border';
          goldenBorderDom.style.backgroundImage = `url('https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309430393.png')`;

          const frontStarDom = document.createElement('img');
          frontStarDom.src = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309335054.png?x-oss-process=image/resize,w_200,limit_0';
          frontStarDom.className = 'front-star';

          const backStarDom = document.createElement('img');
          backStarDom.src = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309351951.png?x-oss-process=image/resize,w_200,limit_0';
          backStarDom.className = 'back-star';

          const whiteStarDom = document.createElement('img');
          whiteStarDom.src = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309367894.png?x-oss-process=image/resize,w_200,limit_0';
          whiteStarDom.className = 'white-star';

          const goldrenBlockFirstDom = document.createElement('div');
          goldrenBlockFirstDom.className = 'golden-block first'
          goldrenBlockFirstDom.style.backgroundImage = `url('https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309465232.png')`;
          const goldrenBlockSecDom = document.createElement('div');
          goldrenBlockSecDom.className = 'golden-block sec'
          goldrenBlockSecDom.style.backgroundImage = `url('https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571309465232.png')`;

         
          (oFrag as DocumentFragment).appendChild(frontStarDom);
          (oFrag as DocumentFragment).appendChild(backStarDom);
          (oFrag as DocumentFragment).appendChild(whiteStarDom);
          (oFrag as DocumentFragment).appendChild(goldenBorderDom);
          (oFrag as DocumentFragment).appendChild(goldrenBlockFirstDom);
          (oFrag as DocumentFragment).appendChild(goldrenBlockSecDom);

          (ownDom as HTMLElement).appendChild(oFrag);
          if (goldrenBlockFirstDom || goldrenBlockSecDom ) {
            setTimeout(() => {
              (goldrenBlockFirstDom as HTMLDivElement).style.opacity = '1';
            }, 3000);
            setTimeout(() => {
              (goldrenBlockFirstDom as HTMLDivElement).style.opacity = '0';
            }, 3500);
            setTimeout(() => {
              (goldrenBlockSecDom as HTMLDivElement).style.opacity = '1';
            }, 4000);
            setTimeout(() => {
              (goldrenBlockSecDom as HTMLDivElement).style.opacity = '0';
            }, 4500);
          }
        }
        this.parentDom.appendChild(ownDom);
        setTimeout(() => {
          (ownDom as HTMLElement).style.cssText += 'right: 10rem';
          setTimeout(() => {
            (ownDom.parentNode as HTMLElement).removeChild(ownDom);
            // this.barrageList.push(barrageItem);
          }, this.duration);
        }, 1000);

      }
    }

  }

  public unregister(): void {
    clearInterval(this.timer);
  }
}

export default Barrage;
